import type { UserRole } from '@ils/static/enums.js';
import type { User } from './permissions.js';
import { roleMapping } from './roleMapping.js';
import { permissions } from './roles/permissions.js';

export const getAllowedPageKeys = (user: User): string[] => {
  const userRoles = user.roles.map(role => roleMapping[role.name] ?? role.name) as UserRole[];
  let pages: string[] = [];
  for (const role of userRoles) {
    pages = pages.concat(Object.keys(permissions[role].allowedPages));
  }
  return Array.from(new Set(pages));
};
